import React, { useEffect, useRef } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { gsap } from 'gsap'

import staggerAnimation from '../../utils/staggerAnimation'
import { Icon, AccessibleHiddenText, Link } from '..'
import { iconsKeys } from '../Icon/Icon.assets'

import useStyles from './styles'


const Header = (props) => {
  const classes = useStyles(props)
  const { className, title, linkLogoProps, isH1, isFallHidden, navigation } = props

  const renderLogoWithH1 = (logoDOM) => (isH1 ? (
    <h1 className={classes.logoMainWrapper}>{logoDOM}</h1>
  ) : (
    <div className={classes.logoMainWrapper}>{logoDOM}</div>
  ))

  const renderLogoWithLink = (logoDOM) => (linkLogoProps ? (
    <Link
      className={classes.logoMainLink}
      {...linkLogoProps}
    >
      {logoDOM}
    </Link>
  ) : logoDOM)


  // animations
  const $animatedWrapper = useRef()

  useEffect(() => {
    const timeline = gsap.timeline()

    if ($animatedWrapper.current) {
      const animatedChildren = Array.from($animatedWrapper.current.children).filter((child) => !child.classList.contains('is-notstaggered'))

      staggerAnimation(0, animatedChildren, timeline, 0.1, '+=0.2', 0.5)
      timeline.play()
    }
    // cleanup
    return () => {
      timeline.clear()
    }
  }, [])

  return (
    <header className={cx(className, classes.container)}>
      <div
        className={classes.wrapper}
        ref={$animatedWrapper}
      >
        {renderLogoWithH1(
          renderLogoWithLink(
            <>
              <AccessibleHiddenText text={title} />
              <Icon
                icon={iconsKeys.Logo}
                className={classes.logoMain}
                aria-hidden="true"
              />
            </>
          )
        )}
        {/* TODO transition here maybe */}
        {!isFallHidden && (
          <div className={classes.logoFallWrapper}>
            <Icon
              icon={iconsKeys.Fall21}
              className={classes.logoFall}
              aria-hidden="true"
            />
          </div>
        )}
        {navigation && <div className={classes.navigation}>{navigation}</div>}
      </div>
    </header>
  )
}

Header.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  linkLogoProps: PropTypes.object,
  isH1: PropTypes.bool,
  isFallHidden: PropTypes.bool,
  navigation: PropTypes.node,
}

Header.defaultProps = {
  className: null,
  title: 'Balenciaga',
  linkLogoProps: null,
  isH1: false,
  isFallHidden: false,
  navigation: null,
}

export default Header
